// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hosted-field-frame {
  padding: 1px;
  min-height: 60px;
  width: 100%;
  display: block;
  overflow: hidden;
}
.hosted-field-frame.card-frame {
  min-height: 85px;
}

.hosted-label {
  font-weight: 600;
  margin-bottom: 4px;
  display: block;
}

.invalid {
  border-color: #bb1e32 !important;
}

input:focus {
  outline: none;
  border-color: #007bff !important;
}

.payment-title {
  padding-left: 3px;
  margin-bottom: 30px;
}

.payment-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 10px 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/nepting-payment/nepting-payment.page.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;AACD;AACC;EACC,gBAAA;AACF;;AAGA;EACC,gBAAA;EACA,kBAAA;EACA,cAAA;AAAD;;AAGA;EACC,gCAAA;AAAD;;AAIC;EACC,aAAA;EACA,gCAAA;AADF;;AAKA;EACC,iBAAA;EACA,mBAAA;AAFD;;AAKA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;AAFD","sourcesContent":[".hosted-field-frame {\n\tpadding: 1px;\n\tmin-height: 60px;\n\twidth: 100%;\n\tdisplay: block;\n\toverflow: hidden;\n\n\t&.card-frame {\n\t\tmin-height: 85px;\n\t}\n}\n\n.hosted-label {\n\tfont-weight: 600;\n\tmargin-bottom: 4px;\n\tdisplay: block;\n}\n\n.invalid {\n\tborder-color: #bb1e32 !important;\n}\n\ninput {\n\t&:focus {\n\t\toutline: none;\n\t\tborder-color: #007bff !important;\n\t}\n}\n\n.payment-title {\n\tpadding-left: 3px;\n\tmargin-bottom: 30px;\n}\n\n.payment-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 20px 10px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
